
import ContractsCoverImage from '@/components/Settings/Contracts/ContractsCoverImage'
import ContractsBgImage from '@/components/Settings/Contracts/ContractsBgImage'
import Tenant from '@/components/Settings/Tenant/Tenant'
import ProfilePersonalInfo from '@/components/Settings/Profile/ProfilePersonalInfo'
import ProfileImage from '@/components/Settings/Profile/ProfileImage'
import PasswordUpdate from '@/components/Settings/Security/PasswordUpdate'
import TrustedDevices from '@/components/Settings/Security/TrustedDevices.vue'
import TwoFactorAuth from '@/components/Settings/Security/TwoFactorAuth'
import EmailUpdate from '@/components/Settings/Profile/EmailUpdate'
import Redeem from '@/components/Settings/Coupon/Redeem'
import DisableNotifications from '@/components/Settings/Notifcation/DisableNotifications'
import Setting from '@/components/Settings/Setting'
import DeleteAccount from '@/components/Settings/Profile/DeleteAccount.vue'
// import EmailsManage from '@/components/Settings/Profile/EmailsManage.vue'

export default {
    components: {
        Setting
    },
    data () {
        return {
            page: '',
            pages: [
                {
                    title: this.$t('settings profile'),
                    query: 'profile',
                    components: [ProfilePersonalInfo, ProfileImage, EmailUpdate, DeleteAccount]
                },
                {
                    title: this.$t('settings security'),
                    query: 'security',
                    components: [PasswordUpdate, TrustedDevices, TwoFactorAuth]
                },
                {
                    title: this.$t('settings notifications'),
                    query: 'notifications',
                    components: [DisableNotifications]
                },
                {
                    title: this.$t('settings coupon'),
                    query: 'coupon',
                    components: [Redeem]
                }
            ]
        }
    },
    computed: {
        selectedPage () {
            return this.pages.find(p => p.query === this.page) || this.pages[0]
        }
    },
    created () {
        if (this.$can('workers')) {
            this.pages.push({
                title: this.$t('contracts page'),
                query: 'contracts',
                components: [ContractsCoverImage, ContractsBgImage]
            })
        }
        if (this.$auth?.user.has_team && this.$auth?.user?.is_tenant_owner) {
            this.pages.push({
                title: this.$t('team page'),
                query: 'team',
                components: [Tenant]
            })
        }
        const queryPage = this.$route.query.page ?? ''
        const page = this.pages.find(p => p.query === queryPage)
        this.selectPage(page)
    },
    methods: {
        selectPage (page) {
            if (page) {
                this.page = page.query
                this.pageMobile = this.page
                this.$router.push({
                    path: this.$route.path,
                    query: Object.assign({}, this.$route.query, { page: this.page === '' ? undefined : this.page })
                })
            }
        }
    },
    head () {
        return {
            title: this.$t('settings page')
        }
    }
}
